import React from 'react'
import styles from './CardList.module.scss'
import parse from 'html-react-parser'
import { Heading } from '~elements'
import Image from 'next/image'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { CardListProps, CardListCardProps } from '~types'

const CardListGroupCard = ({ description, details, headline, subHeadline, image }: CardListCardProps) => {
  return (
    <div className={styles.card}>
      {image?.url && (
        <div className={'image-container'}>
          <Image
            src={image.url}
            alt={image?.altText ?? headline ?? ''}
            width='0'
            height='0'
            sizes='100vw'
            quality={NEXT_IMAGE_QUALITY}
          />
        </div>
      )}
      {headline && <Heading level={3}>{headline}</Heading>}
      {subHeadline && (
        <Heading level={4} levelDisplay='eyebrow' color='accent'>
          {subHeadline}
        </Heading>
      )}
      {description && description?.html && <div className={styles['card-description']}>{parse(description.html)}</div>}
      {details && details?.html && <div className={styles['card-details']}>{parse(details.html)}</div>}
    </div>
  )
}

const CardList = ({ groupCards, ...cardProps }: CardListProps) => {
  if (groupCards?.length > 0) {
    return (
      <div className={styles['cards-plan-visit-page']}>
        {groupCards.map((card, index) => (
          <CardListGroupCard key={`card-${index}`} {...card} />
        ))}
      </div>
    )
  }
  return <CardListGroupCard {...cardProps} />
}

export default CardList
